module.exports = __webpack_public_path__ + "img/login_ad_mobile.885d7679.jpg";